import styled from 'styled-components';
import { sx } from '../../';
export const StyledButton = styled.button.withConfig({
  displayName: "types__StyledButton",
  componentId: "sc-uhtrt2-0"
})(["", ";"], sx);